const isBrowser = typeof window !== 'undefined';

export default {
  setItem: (key: string, value: any) => isBrowser && window.localStorage.setItem(key, value),
  getItem: (key: string) => isBrowser && window.localStorage.getItem(key),
  removeItem: (key: string) => isBrowser && window.localStorage.removeItem(key),
};
